var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRenewableEnergy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Renewable-Energy-Solar-Power--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Renewable Energy Solar Power Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.92 15.51a0.88 0.88 0 0 0 -0.79 -0.51H21.5a0.5 0.5 0 0 1 -0.5 -0.5v-5a0.5 0.5 0 0 0 -0.89 -0.31l-5.9 7.37a0.87 0.87 0 0 0 0.67 1.44h1.62a0.5 0.5 0 0 1 0.5 0.5v5a0.5 0.5 0 0 0 0.89 0.31l5.9 -7.37a0.88 0.88 0 0 0 0.13 -0.93Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3a1 1 0 0 0 1 -1V1a1 1 0 0 0 -2 0v1a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61 4A1 1 0 1 0 4 2.61l-0.68 -0.71A1 1 0 0 0 1.9 3.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5a1 1 0 0 0 -1 -1H1a1 1 0 0 0 0 2h1a1 1 0 0 0 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.61 9 -0.71 0.71a1 1 0 1 0 1.42 1.39l0.68 -0.71A1 1 0 1 0 2.61 9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -2 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9a1 1 0 0 0 0 1.42l0.7 0.71a1 1 0 1 0 1.4 -1.45L10.39 9A1 1 0 0 0 9 9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5a1 1 0 0 0 1 1h1a1 1 0 0 0 0 -2h-1a1 1 0 0 0 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.39 4 0.71 -0.71A1 1 0 1 0 9.68 1.9L9 2.61A1 1 0 1 0 10.39 4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.65 5.81a0.5 0.5 0 0 0 0.86 -0.35 0.37 0.37 0 0 1 0.16 -0.31 0.39 0.39 0 0 1 0.35 0 7.12 7.12 0 0 1 2.67 2.24 1 1 0 0 0 1.62 -1.19 9 9 0 0 0 -4.46 -3.29 0.5 0.5 0 0 1 -0.34 -0.47v-1A0.5 0.5 0 0 0 15.2 1a0.53 0.53 0 0 0 -0.55 0.11l-2 2a0.51 0.51 0 0 0 0 0.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36 17.1a0.51 0.51 0 0 0 -0.54 -0.11 0.5 0.5 0 0 0 -0.31 0.47 0.38 0.38 0 0 1 -0.17 0.3 0.37 0.37 0 0 1 -0.34 0 7.08 7.08 0 0 1 -3.21 -3.1 1 1 0 0 0 -1.34 -0.42A1 1 0 0 0 5 15.61 9 9 0 0 0 10.16 20a0.49 0.49 0 0 1 0.35 0.47v1a0.5 0.5 0 0 0 0.31 0.46 0.58 0.58 0 0 0 0.18 0.07 0.53 0.53 0 0 0 0.35 -0.15l2 -2a0.5 0.5 0 0 0 0 -0.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRenewableEnergy);
export default ForwardRef;